export default __webpack_public_path__ + "static/media/getFetch.8ff3c934.cjs";